import TNTControlBase from '../../util/TNTControlBase';

class MobileAppController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'mobile_app'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_'+this.id]) {
      this.hasACL[this.acl['tnt_control_'+this.id][key]] = true;
    }
  }
}

export default MobileAppController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/mobile_app.controller.js